import Grid from '@material-ui/core/Grid';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import React from 'react';
import FormSection from '../../../../components/atom/FormSection';
import FormikInput from '../../../../components/atom/FormikInput';
import PriceRuleSelect from '../../../../components/atom/PriceRuleSelect';
import { useIslands } from '../../../../hooks/useIslands';
import GlcodeEditor from '../../../../components/glcode/GlcodeEditor';

const showTaxesAndFeesOptions = [
    { id: 'aggregated', name: 'Aggregated' },
    { id: 'detailed', name: 'Detailed' },
    { id: 'taxes_and_fees_per_ticket', name: 'Per ticket' }
];

export default function ClientEditGenericSettings({ values, setFieldValue }) {
    const [islands] = useIslands(true);
    return (
        <FormSection title="Generic settings">
            <FormikInput name="name" label="Name*" xs={12} sm={12} />
            <FormikInput name="legal_name" label="Legal name" xs={12} sm={12} />
            <Grid item xs={6}>
                <FormControlLabel
                    label="Vendor (having activities)"
                    control={
                        <Checkbox
                            color="primary"
                            checked={values.is_vendor}
                            onChange={e => setFieldValue('is_vendor', !!e.target.checked)}
                        />
                    }
                />
            </Grid>
            <Grid item xs={6}>
                <FormControlLabel
                    label="Client (has branded booking site)"
                    control={
                        <Checkbox
                            color="primary"
                            checked={values.is_client}
                            onChange={e => setFieldValue('is_client', !!e.target.checked)}
                        />
                    }
                />
            </Grid>
            <FormikInput name="address" label="Address" xs={6} sm={6} />
            <Grid item xs={6} sm={6}>
                <PriceRuleSelect
                    fullWidth
                    label="Show taxes and fees"
                    options={showTaxesAndFeesOptions}
                    resolveIds
                    value={values.show_taxes_and_fees}
                    setValue={newVal => setFieldValue('show_taxes_and_fees', newVal)}
                />
            </Grid>
            <FormikInput name="tax_number" label="Tax number" xs={6} sm={6} />
            <Grid item xs={6} sm={6}>
                <PriceRuleSelect
                    fullWidth
                    label="Island of taxation"
                    options={islands}
                    value={
                        values.tax_island_id
                            ? islands.find(i => i.id === values.tax_island_id)?.name
                            : ''
                    }
                    setValue={newVal => setFieldValue('tax_island_id', newVal)}
                />
            </Grid>
            <FormikInput
                multiline
                label="Admin notes"
                fullWidth
                name="admin_notes"
                xs={12}
                sm={12}
            />
            <FormikInput name="vendor_number" label="Vendor number" xs={12} sm={12} />
            <Grid item xs={6} sm={6}>
                <h4>Sales GL code</h4>
                <GlcodeEditor
                    value={values?.client_gl}
                    setValue={glCode => setFieldValue('client_gl', glCode)}
                />
            </Grid>
            <Grid item xs={6} sm={6}>
                <h4>Cost GL code</h4>
                <GlcodeEditor
                    value={values?.vendor_gl}
                    setValue={glCode => setFieldValue('vendor_gl', glCode)}
                />
            </Grid>
        </FormSection>
    );
}
